export const calculateTotalRooms = (bookingSidebar) => {
  return bookingSidebar.reduce(
    (total, plan) => total + (plan.selectedRooms || 0),
    0
  );
};
